import { render, staticRenderFns } from "./EditBoard.vue?vue&type=template&id=196ba8c3&"
import script from "./EditBoard.vue?vue&type=script&lang=js&"
export * from "./EditBoard.vue?vue&type=script&lang=js&"
import style0 from "./EditBoard.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports